export enum CivilStatusCode {
  SOLTERO = '01',
  CASADO = '02',
  VIUDO = '03',
  DIVORCIADO = '04',
  CONVIVIENTE = '05',
}

export enum RegimeTypeCode {
  SOCIEDAD_GANANCIALES = '01',
  SEPARACION_PATRIMONIOS = '02',
  UNION_HECHO = '03',
}
export enum CivilStatusId {
  SOLTERO = 1,
  CASADO = 2,
  DIVORCIADO = 3,
  VIUDO = 4,
  CONVIVIENTE = 5,
}
export enum RegimeTypeId {
  SEPARACION_PATRIMONIOS = 1,
  SOCIEDAD_GANANCIALES = 2,
  UNION_HECHO = 3,
}
export enum DocumentTypeCode {
  DNI = '01',
  CARNET_EXTRANJERIA = '04',
  PASAPORTE = '07',
  RUC = '06',
  OTRO = '00',
}

export const getIdByCode = <T extends { code: string; id: number }>(
  list: T[] | undefined,
  code: string
) => list?.find((i) => i.code === code)?.id;

export const filterByCodes = <T extends { code: string }>(
  list: T[] | undefined,
  codes: string[]
) => (list ?? []).filter((i) => codes.includes(i.code));

export function filterDocumentTypesByCodes(data: any, allowedCodes: string[]) {
  if (!data) return [];
  return data.filter((item: any) => allowedCodes.includes(item.code));
}
